export const initialValues = {
  phone: "",
  confirmCode: "",
};

export const phoneLength = 12;
